import { render, staticRenderFns } from "./TableManager.vue?vue&type=template&id=65b47bf0&scoped=true&"
import script from "./TableManager.vue?vue&type=script&lang=ts&"
export * from "./TableManager.vue?vue&type=script&lang=ts&"
import style0 from "./TableManager.vue?vue&type=style&index=0&id=65b47bf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b47bf0",
  null
  
)

export default component.exports